import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Box, Stack, Typography } from '@mui/material'

import { RootState } from 'store'
import TripBuilderAddButton from './trip-builder-add-button'
import TripBuilderRowAction from './trip-builder-row-action'
import TripDriverSelectionPanel from './trip-driver-selection-panel'

const TripDriverSection = () => {
  const [selectionOpen, setSelectionOpen] = useState(false)
  const firstDriver = useSelector((state: RootState) => state.trips.firstDriver)
  const firstDriverId = useSelector(
    (state: RootState) => state.trips.tripsPayload.firstDriverId
  )
  const firstDriverName = useSelector(
    (state: RootState) => state.trips.tripsPayload.firstDriverName
  )

  const hasDriver = Boolean(firstDriver.id || firstDriverId)
  const nameFromDriver =
    `${firstDriver.firstName ?? ''} ${firstDriver.lastName ?? ''}`.trim()
  const driverName =
    nameFromDriver || firstDriverName?.trim() || firstDriver.phone || 'Driver'
  const showPhone = Boolean(nameFromDriver && firstDriver.phone)

  return (
    <>
      {!hasDriver ? (
        <TripBuilderAddButton
          label="+ Add driver"
          onClick={() => setSelectionOpen(true)}
        />
      ) : (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '8px',
            bgcolor: 'common.white',
            px: 2,
            py: 1.5,
          }}
        >
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              fontWeight={600}
              sx={{ mb: 0.25 }}
            >
              Driver
            </Typography>
            <Typography fontWeight={700} noWrap>
              {driverName}
            </Typography>
            {showPhone && (
              <Typography variant="body2" color="text.secondary" noWrap>
                {firstDriver.phone}
              </Typography>
            )}
          </Box>
          <TripBuilderRowAction
            label="Change driver"
            onClick={() => setSelectionOpen(true)}
          />
        </Stack>
      )}

      <TripDriverSelectionPanel
        open={selectionOpen}
        onClose={() => setSelectionOpen(false)}
      />
    </>
  )
}

export default TripDriverSection
